import { Grid, Typography } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import { useEffect, useState } from "react"
import { getExpenseAnnualTotal, getExpensesFromMonzo, getIncomeAfterExpenses, processMonzoExpenses } from "../store/store"
import { useParams, useSearchParams } from "react-router"
import dayjs from "dayjs"
import { useFinances } from "../store/FinancesContext"
import { MoneyTextFormat } from "../money"

function Monzo() {

    var { year } = useParams()
    var finances = useFinances()


    // transactions
    const [monzoTransactions, setMonzoTransactions] = useState([])

    useEffect(() => {
        async function fetchData() {
            processMonzoExpenses(finances, year).then((r) => {
                setMonzoTransactions(r)
            })
        }

        fetchData()

    }, [])



    console.log(monzoTransactions)
    return <Grid container size={12} spacing={2}>
        <Grid item size={12}>
            <Typography variant='h6'>Categoroies</Typography>
        </Grid>
        <Grid item size={12}>
            <DataGrid autoHeight disableColumnResize disableColumnMenu disableRowSelectionOnClick columns={[
                {
                    field: 'id',
                    headerName: 'Category',
                    hide: true,
                    minWidth: 130,
                    flex: 1
                },
                {
                    field: 'Planned',
                    flex: 1.5,
                    renderCell: (params) => {
                        return <MoneyTextFormat value={params.row.planned} />
                    }
                },
                {
                    field: 'To Date',
                    flex: 2,
                    renderCell: (params) => {
                        return <>
                            <MoneyTextFormat value={params.row.sum.net} /> (<MoneyTextFormat value={params.row.sum.net + params.row.sum.savings} />)
                        </>
                    }
                }
            ]} rows={monzoTransactions} />
        </Grid>
    </Grid>

}

export default Monzo